export const RequestsTypeFeatureKey = 'requests-type';
